import usePrivateAxios from '@/common/api/usePrivateAxios'
import { RoleData } from '@/common/types/roles'
import { getRailsUpdate } from '@/common/utils/getRailsUpdate'
import { mapToDeletion } from '@/common/utils/railsHelpers'
import { RoleValidationSchema } from '@/features/tcardRoles/schemas/create.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateEstablishmentRoleProps {
  roleId: string
  initialRole?: RoleData
  onSuccess: () => void
  onError: (error: any) => void
}

export const useUpdateEstablishmentRole = ({
  roleId,
  initialRole,
  onSuccess,
  onError,
}: UseUpdateEstablishmentRoleProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentRole'],
    mutationFn: async ({
      form,
      selectedPermissions,
    }: {
      form: RoleValidationSchema
      selectedPermissions: { permission_id: string }[]
    }) => {
      const payload = {
        display_name: form.display_name,
        description: form.description,
        permission_roles_attributes: getRailsUpdate(
          initialRole?.permission_roles || [],
          selectedPermissions,
          (value) => value.permission.id,
          (value) => value.permission_id,
          mapToDeletion,
          (value) => ({ ...value }),
        ),
        level: form.level !== undefined ? Number(form.level) || 0 : undefined,
      }

      return privateAxios.put(`/establishment/roles/${roleId}`, { ...payload })
    },
    onSuccess,
    onError,
  })
}
